import React, { Fragment, useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { logout } from "../../actions/auth";
import Login from "../auth/Login";
import Register from "../auth/Register";
import NavBundles from "../bundle/NavBundles";
import UserProfile from "../user/UserProfile";
import UserPasswordChange from "../user/UserPasswordChange";
import usePhotoOffer from "../photo/usePhotoOffer";
import { PARTNER_PATHS } from "../partner/PartnerOffers";
import {
  showDropDown,
  hideDropDown,
  showPassChange,
  showProfile,
} from "../../actions/user";
import useOnclickOutside from "react-cool-onclickoutside";

// The header of every page (App.js), fixed to the top; .app-page leaves room for it.
// Its profile and password popups live here too, so they open from any page.
// Any path can show it, nested ones included, so the logo needs an absolute src.
const Navbar = ({
  auth: { isAuthenticated, loading, user },
  logout,
  user_dropdown,
  change_pass,
  show_profile,
  showDropDown,
  hideDropDown,
  showPassChange,
  showProfile,
}) => {
  const { pathname } = useLocation();
  const photos = usePhotoOffer();

  // Whether the open auth dialog took over from the other one
  const [authSwitched, setAuthSwitched] = useState(false);
  const [isShowingLogin, setIsShowingLogin] = useState(false);
  const toggle = () => {
    setIsShowingLogin(!isShowingLogin);
    setAuthSwitched(false);
  };
  const [isShowingRegister, setIsShowingRegister] = useState(false);
  const toggleRegister = () => {
    setIsShowingRegister(!isShowingRegister);
    setAuthSwitched(false);
  };

  const ref = useOnclickOutside(() => {
    hideDropDown();
  });

  const [isActive, setisActive] = useState(false);

  // A link followed from the phone menu or the user dropdown closes it
  useEffect(() => {
    setisActive(false);
    hideDropDown();
  }, [pathname, hideDropDown]);

  // `paths` are the pages a link stays marked on
  const links = [
    {
      to: isAuthenticated ? "/upload" : "/",
      label: "Файл илгээх",
      paths: ["/", "/upload"],
    },
    { to: "/templates", label: "Бэлэн загвар", paths: ["/templates", "/template"] },
    photos && (photos.price || photos.idPrice) && {
      to: photos.price ? "/photo" : "/idphoto",
      label: "Зураг хэвлэх",
      paths: ["/photo", "/idphoto"],
    },
    // A customer's own bundles are NavBundles, on the right
    !loading && !isAuthenticated && { to: "/bundles", label: "Багц", paths: ["/bundles"] },
    // For organizations rather than print customers: kiosks and ads
    { to: "/partners", label: "Хамтран ажиллах", paths: PARTNER_PATHS },
  ].filter(Boolean);

  const userLinks = (
    <Fragment>
      <NavBundles />
      <div
        className={`dropdown navbar-item ${user_dropdown ? "is-active" : ""}`}
        ref={ref}
      >
        <div className="dropdown-trigger">
          <span
            className="button signup-button user-profile nav-profile-button"
            style={{ whiteSpace: "normal", wordWrap: "break-word" }}
            aria-controls="dropdown-menu"
            onClick={showDropDown}
          >
            <span>
              <i className="fas fa-user"></i>
            </span>
            <span className="icon is-small">
              <i className="fas fa-angle-down" aria-hidden="true"></i>
            </span>
          </span>
        </div>
        <div
          className="dropdown-menu user-profile-dropdown"
          id="dropdown-menu"
          role="menu"
        >
          <div className="dropdown-content">
            <button type="button" className="dropdown-item" onClick={showProfile}>
              Профайл
            </button>
            <button type="button" className="dropdown-item" onClick={showPassChange}>
              Нууц үг солих
            </button>
          </div>
        </div>
      </div>

      <button
        type="button"
        className="navbar-item modal-trigger home-nav-button"
        data-modal="reg-modal"
        onClick={() => {
          logout();
        }}
      >
        <span className="button signup-button nav-logout-button" style={{}}>
          Гарах
        </span>
      </button>
    </Fragment>
  );

  const guestLinks = (
    <Fragment>
      <Link
        to="/login"
        onClick={(event) => {
          event.preventDefault();
          toggle();
        }}
        className="navbar-item modal-trigger"
        data-modal="auth-modal"
      >
        <span className="button signup-button nav-login-button">
          <i className="fas fa-sign-in-alt" aria-hidden="true"></i>
          <span>Нэвтрэх</span>
        </span>
      </Link>
      <Link
        to="/register"
        className="navbar-item modal-trigger"
        data-modal="reg-modal"
        onClick={(event) => {
          event.preventDefault();
          toggleRegister();
        }}
      >
        <span
          className="button signup-button rounded primary-btn raised"
          style={{ borderColor: "#46bd9b" }}
        >
          Бүртгүүлэх
        </span>
      </Link>
    </Fragment>
  );

  return (
    <Fragment>
      <nav
        className="navbar app-navbar is-fixed-top is-white has-shadow"
        role="navigation"
        aria-label="main navigation"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link to="/" className="navbar-item home-navbar-brand" aria-label="Cloud Print нүүр хуудас">
              <img
                src="/assets/img/cloudprint-logo.png"
                width="164"
                height="100"
                alt="Cloud Print"
                className="navbar-logo"
              />
            </Link>
            <button
              type="button"
              onClick={() => setisActive(!isActive)}
              className={`navbar-burger burger ${isActive ? "is-active" : ""}`}
              aria-label="menu"
              aria-expanded={isActive}
              data-target="mainNavbar"
            >
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </button>
          </div>

          <div
            id="mainNavbar"
            className={`navbar-menu ${isActive ? "is-active" : ""}`}
          >
            <div className="navbar-start app-nav-links">
              {links.map((link) => (
                <NavLink
                  key={link.label}
                  to={link.to}
                  className="navbar-item app-nav-link"
                  activeClassName="is-current"
                  isActive={() => link.paths.includes(pathname)}
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
            <div className="navbar-end">
              {!loading && (isAuthenticated ? userLinks : guestLinks)}
            </div>
          </div>
        </div>
      </nav>

      {!loading && !isAuthenticated && (
        <Fragment>
          <Login
            isShowing={isShowingLogin}
            hide={toggle}
            switched={authSwitched}
            openRegister={() => {
              setIsShowingLogin(false);
              setIsShowingRegister(true);
              setAuthSwitched(true);
            }}
          />
          <Register
            isShowingRegister={isShowingRegister}
            hideRegister={toggleRegister}
            switched={authSwitched}
            openLogin={() => {
              setIsShowingRegister(false);
              setIsShowingLogin(true);
              setAuthSwitched(true);
            }}
          />
        </Fragment>
      )}

      {isAuthenticated && user && (
        <Fragment>
          <UserPasswordChange isShowing={change_pass} />
          <UserProfile isShowing={show_profile} user={user} />
        </Fragment>
      )}
    </Fragment>
  );
};

Navbar.propTypes = {
  logout: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  user_dropdown: state.user.user_dropdown,
  change_pass: state.user.change_pass,
  show_profile: state.user.show_profile,
});

export default connect(mapStateToProps, {
  logout,
  showDropDown,
  hideDropDown,
  showPassChange,
  showProfile,
})(Navbar);
